import { openOrderModal } from "./order-modal.js";

const orderBlockContainer = document.querySelector('#order-block');
const cartTotalText = document.querySelectorAll('.cart-widget__total');
const cartWidget = document.querySelector('.cart-widget');
const cartPopoverToggle = cartWidget.querySelector('.cart-widget__toggle');
const cartPopoverClose = cartWidget.querySelector('.cart-popover__close');
const cartPopoverButtoon = cartWidget.querySelector('.cart-popover__button');

const getСartTotal = (data) => {
  cartTotalText.forEach( (el) => {
    el.textContent = data.length;
  });
}

const visibilityCartWidget = (items) => {
  if (items.length > 0) {
    cartWidget.classList.add('show');
  }
}

const initCartWidget = () => {

  cartPopoverToggle?.addEventListener('click', () => {
    cartWidget.classList.toggle('is-active');
  });

  cartPopoverClose?.addEventListener('click', () => {
    cartWidget.classList.remove('is-active');
  });

  if (!orderBlockContainer) {
    cartPopoverButtoon?.addEventListener('click', openOrderModal);
  } else {
    const  cartPopoverLink = document.createElement('a');
    cartPopoverLink.classList.add(cartPopoverButtoon.className);
    cartPopoverLink.href = '#' + orderBlockContainer.id;
    cartPopoverLink.textContent = cartPopoverButtoon.textContent;
    cartPopoverButtoon.replaceWith(cartPopoverLink);
  }
};

export { 
  initCartWidget, 
  visibilityCartWidget, 
  getСartTotal 
};